// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","caption":"_1dJD2pSCq2-UhXWE_3mRfd","customWhite":"#ffffff","mediumMaxWidth":"1199px","container":"_2gYti5Nor8-Tn_yaxbWOx8","label":"_2juShxP84afi1MIOY_wlXU _1dJD2pSCq2-UhXWE_3mRfd","active":"A-Uq5ntIMC3r5PI5B57_i","image":"PyGf5HuVG8Pc5Y1sfqWY5"};


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-navbar/progress-bullet/ProgressBullet.css
// module id = 692
// module chunks = 0